/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} General_Loginheaderlp3Inputs */

const en_general_loginheaderlp3 = /** @type {(inputs: General_Loginheaderlp3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.companyName} Investor Portal`)
};

/**
* | output |
* | --- |
* | "{companyName} Investor Portal" |
*
* @param {General_Loginheaderlp3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const general_loginheaderlp3 = /** @type {((inputs: General_Loginheaderlp3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Loginheaderlp3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_general_loginheaderlp3(inputs)
});
export { general_loginheaderlp3 as "general_loginHeaderLP" }